<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>{{ editing ? ('Editar: ' + editing.nombre) : 'Editor de Herramientas' }}</f7-nav-title>
      <f7-nav-right><HelpButton titulo="Editor de Herramientas de Tarifas" :contenido="helpEditorHTML" /></f7-nav-right>
    </f7-navbar>

    <!-- ══ LISTA ══ -->
    <f7-page-content v-if="!editing">
      <div class="ed-wrap">
        <div class="ed-top">
          <h2 class="ed-title">Herramientas de Tarifas</h2>
          <button class="ed-btn ed-btn-p" @click="nuevaHerramienta">+ Nueva herramienta</button>
        </div>
        <div class="ed-grid">
          <div class="ed-card" v-for="h in herramientas" :key="h.id||h.codigo">
            <span class="ed-ico">{{ h.icono||'📐' }}</span>
            <div class="ed-info">
              <b>{{ h.nombre }}</b>
              <span class="ed-fam">{{ h.familia }} · {{ h.codigo }} (v.{{ h.version||1 }})</span>
              <span v-if="h.fechaDesde" class="ed-ver-fecha">Vigente desde {{ formatFechaEd(h.fechaDesde) }}</span>
            </div>
            <span class="ed-badge" :class="h.activo?'ed-on':'ed-off'">{{ h.activo?'Activo':'Inactivo' }}</span>
            <button class="ed-btn ed-btn-s" @click="editarHerramienta(h)">Editar</button>
            <button class="ed-btn ed-btn-s" :disabled="!!motivoNoDuplicar(h)" @click="duplicarHerramienta(h)">Duplicar</button>
            <!-- Junto al boton y no en un aviso de cabecera: quien pulsa no relaciona lo uno con lo
                 otro (reglas de pantalla de direccion, 05/10/2026). -->
            <p v-if="motivoNoDuplicar(h)" class="ed-nodup">{{ motivoNoDuplicar(h) }}</p>
          </div>
        </div>
      </div>
    </f7-page-content>

    <!-- ══ EDITOR ══ -->
    <div v-else class="ed-editor">
      <div class="ed-tabs">
        <button v-for="t in tabs" :key="t.key" class="ed-tab" :class="{act:activeTab===t.key}" @click="activeTab=t.key">{{ t.icon }} {{ t.label }}</button>
        <span v-if="editing && !isNew" style="font-size:9px;color:rgba(255,255,255,.4);margin-left:8px">v{{ editing.version||1 }} · Config v{{ editing.configGlobalVersion||1 }}</span>
        <div style="flex:1"></div>
        <button class="ed-btn ed-btn-p" @click="guardar">💾 Guardar</button>
        <!-- Abre la calculadora, que solo carga versiones guardadas. Lo que hay en pantalla sin
             guardar se calcula en «Casos de prueba» (#1185). -->
        <button class="ed-btn ed-btn-s" title="Abre la calculadora con la versión guardada. Lo que hay en pantalla sin guardar se prueba en «Casos de prueba»." @click="previewHerramienta">👁 Preview</button>
        <button class="ed-btn ed-btn-s" @click="editing=null">✕ Cerrar</button>
      </div>

      <div class="ed-body">

        <!-- TAB 1: DATOS GENERALES -->
        <div v-if="activeTab==='general'" class="ed-panel">
          <div class="ed-section">
            <div class="ed-row">
              <div class="ed-field"><label>Codigo</label><input type="text" v-model="editing.codigo" :disabled="!isNew" placeholder="ej: rebt" /></div>
              <div class="ed-field"><label>Nombre</label><input type="text" v-model="editing.nombre" placeholder="REBT — Baja Tension" /></div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label>Familia</label>
                <select v-model="editing.familia">
                  <option v-for="f in familias" :key="f.key" :value="f.key">{{ f.label }}</option>
                </select>
              </div>
              <div class="ed-field">
                <label>Icono</label>
                <div class="ed-emoji-grid">
                  <button v-for="e in emojis" :key="e" class="ed-emoji" :class="{act:editing.icono===e}" @click="editing.icono=e">{{ e }}</button>
                </div>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field"><label>Subtitulo</label><input type="text" v-model="editing.subtitulo" placeholder="Inspeccion periodica · 1a y 2a" /></div>
              <div class="ed-field"><label>Norma</label><input type="text" v-model="editing.norma" placeholder="RD 842/2002" /></div>
            </div>
            <div class="ed-row">
              <div class="ed-field"><label>Activo</label><div class="ed-toggle" :class="{on:editing.activo}" @click="editing.activo=!editing.activo">{{ editing.activo?'Si':'No' }}</div></div>
              <div class="ed-field"><label>Orden</label><input type="number" v-model.number="editing.orden" min="1" /></div>
            </div>
            <div class="ed-row">
              <div class="ed-field" style="flex:1"><label>Motivo del cambio</label><textarea v-model="motivo" placeholder="Describa el motivo del cambio..." rows="2" style="width:100%;font-size:11px;border:1px solid #d1d5db;border-radius:4px;padding:6px;font-family:inherit;resize:vertical"></textarea></div>
            </div>
            <div v-if="editing && !isNew" class="ed-ver-section">
              <div class="ed-ver-title">VERSIONADO</div>
              <div class="ed-ver-grid">
                <div class="ed-ver-item"><span class="ed-ver-lbl">Version</span><span class="ed-ver-val">v.{{ editing.version||1 }}</span></div>
                <div class="ed-ver-item"><span class="ed-ver-lbl">Vigente desde</span><span class="ed-ver-val">{{ formatFechaEd(editing.fechaDesde) }}</span></div>
                <div class="ed-ver-item"><span class="ed-ver-lbl">Hasta</span><span class="ed-ver-val" :class="!editing.fechaHasta ? 'ed-ver-vigente' : ''">{{ editing.fechaHasta ? formatFechaEd(editing.fechaHasta) : 'Vigente' }}</span></div>
                <div class="ed-ver-item"><span class="ed-ver-lbl">Config Global</span><span class="ed-ver-val">v.{{ editing.configGlobalVersion||'—' }}</span></div>
                <div class="ed-ver-item" v-if="editing.modificadoPor"><span class="ed-ver-lbl">Modificado por</span><span class="ed-ver-val">{{ editing.modificadoPor }}</span></div>
                <div class="ed-ver-item" v-if="editing.motivo"><span class="ed-ver-lbl">Motivo</span><span class="ed-ver-val">{{ editing.motivo }}</span></div>
              </div>
            </div>
          </div>
        </div>

        <!-- TAB 2: CONFIGURACION -->
        <div v-if="activeTab==='config'" class="ed-panel">
          <div class="ed-section">
            <h3 class="ed-sh">Parametros de calculo</h3>
            <div class="ed-row">
              <div class="ed-field">
                <label>TPI % <span class="ed-hint">Porcentaje TPI sobre TPC</span></label>
                <div class="ed-slider-wrap">
                  <input type="range" min="0" max="50" step="1" :value="cfgTpiPct" @input="cambiarTpiPct($event.target.value)" class="ed-slider" />
                  <span class="ed-slider-val">{{ cfgTpiPct }}%</span>
                </div>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label>Tiene 2a inspeccion</label>
                <div class="ed-toggle" :class="{on:cfgTiene2a}" @click="cfgTiene2a=!cfgTiene2a">{{ cfgTiene2a?'Si':'No' }}</div>
              </div>
            </div>
            <div class="ed-row" v-if="cfgTiene2a">
              <div class="ed-field">
                <label>Factor 2a TPC <span class="ed-hint">0.4 = 40%</span></label>
                <input type="number" v-model.number="cfgF2tpc" min="0" max="1" step="0.05" />
              </div>
              <div class="ed-field">
                <label>Factor 2a TPI <span class="ed-hint">0.4 = 40%</span></label>
                <input type="number" v-model.number="cfgF2tpi" min="0" max="1" step="0.05" />
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label>Km minimos override <span class="ed-hint">Dejar vacio para usar global (60)</span></label>
                <input type="number" :value="cfgKmmin" @input="escribirKmmin($event.target.value)" min="0" placeholder="60" />
              </div>
            </div>
          </div>
        </div>

        <!-- TAB 3: SECCIONES Y CAMPOS -->
        <div v-if="activeTab==='secciones'" class="ed-panel">
          <div class="ed-section-top">
            <h3 class="ed-sh">Secciones del formulario</h3>
            <button class="ed-btn ed-btn-p" @click="addSeccion">+ Seccion</button>
          </div>
          <div class="ed-sec-list">
            <div class="ed-sec-card" v-for="(sec,si) in editing.secciones" :key="'s'+si">
              <div class="ed-sec-header" :style="'background:'+colorMap[sec.headerColor||'navy']">
                <span>{{ sec.titulo || 'Sin titulo' }}</span>
                <div>
                  <button class="ed-btn-mini" v-if="si>0" @click="moveSec(si,-1)">▲</button>
                  <button class="ed-btn-mini" v-if="si<editing.secciones.length-1" @click="moveSec(si,1)">▼</button>
                  <button class="ed-btn-mini ed-del" @click="delSeccion(si)">✕</button>
                </div>
              </div>
              <div class="ed-sec-body">
                <div class="ed-row">
                  <div class="ed-field"><label>Titulo</label><input type="text" v-model="sec.titulo" /></div>
                  <div class="ed-field">
                    <label>Color</label>
                    <select v-model="sec.headerColor">
                      <option value="navy">Azul oscuro</option><option value="green">Verde</option><option value="blue">Azul</option><option value="gray">Gris</option><option value="brown">Marron</option>
                    </select>
                  </div>
                  <div class="ed-field"><label>Columnas</label><select v-model.number="sec.gridCols"><option :value="1">1</option><option :value="2">2</option><option :value="3">3</option><option :value="4">4</option><option :value="5">5</option></select></div>
                </div>
                <div class="ed-row">
                  <div class="ed-field ed-field-full">
                    <label>Visible si <span class="ed-hint">Dejar vacio = siempre visible</span></label>
                    <div class="ed-cond">
                      <select v-model="sec._visCampo"><option value="">Siempre</option><option v-for="cf in allCampos" :key="cf" :value="cf">{{ cf }}</option></select>
                      <select v-if="sec._visCampo" v-model="sec._visOp"><option value="===">igual a</option><option value="!==">distinto de</option></select>
                      <input v-if="sec._visCampo" type="text" v-model="sec._visVal" placeholder="valor" style="width:100px" />
                      <button v-if="sec._visCampo" class="ed-btn-mini" @click="applyVisibleSec(sec)">Aplicar</button>
                      <span v-if="sec.visible" class="ed-vis-tag">{{ sec.visible }}</span>
                    </div>
                  </div>
                </div>
                <!-- CAMPOS -->
                <div class="ed-campos-header">
                  <b>Campos ({{ (sec.widgets||[]).length }})</b>
                  <button class="ed-btn ed-btn-sm" @click="addWidget(sec)">+ Campo</button>
                </div>
                <div class="ed-campo" v-for="(w,wi) in (sec.widgets||[])" :key="'w'+si+'-'+wi">
                  <div class="ed-campo-bar">
                    <span class="ed-campo-tipo">{{ tipoLabels[w.tipo]||w.tipo }}</span>
                    <b>{{ w.label||w.campo }}</b>
                    <span class="ed-campo-slug">{{ w.campo }}</span>
                    <div>
                      <button class="ed-btn-mini" v-if="wi>0" @click="moveWidget(sec,wi,-1)">▲</button>
                      <button class="ed-btn-mini" v-if="wi<sec.widgets.length-1" @click="moveWidget(sec,wi,1)">▼</button>
                      <button class="ed-btn-mini" @click="editWidget(si,wi)">✏️</button>
                      <button class="ed-btn-mini ed-del" @click="delWidget(sec,wi)">✕</button>
                    </div>
                  </div>
                  <div class="ed-campo-edit" v-if="editingWidget && editingWidget.si===si && editingWidget.wi===wi">
                    <div class="ed-row">
                      <div class="ed-field">
                        <label>Tipo</label>
                        <select v-model="w.tipo">
                          <option value="number">Numero</option><option value="checkbox">Checkbox</option><option value="select">Selector</option>
                          <option value="radioCard">Radio cards</option><option value="togglePair">Toggle par</option><option value="levelSelector">Nivel riesgo</option>
                          <option value="checkboxCard">Checkbox con sub-input</option><option value="tableCheckboxes">Tabla checkboxes</option>
                        </select>
                      </div>
                      <div class="ed-field"><label>Nombre campo</label><input type="text" v-model="w.campo" placeholder="ej: C" /></div>
                      <div class="ed-field"><label>Etiqueta</label><input type="text" v-model="w.label" placeholder="Nro Cuadros" /></div>
                    </div>
                    <div class="ed-row">
                      <div class="ed-field"><label>Hint</label><input type="text" v-model="w.hint" /></div>
                      <div class="ed-field"><label>Valor defecto</label><input type="text" v-model="w.defaultValue" /></div>
                      <div class="ed-field"><label>Icono</label><input type="text" v-model="w.icono" placeholder="emoji" style="width:50px" /></div>
                    </div>
                    <div class="ed-row" v-if="w.tipo==='number'">
                      <div class="ed-field"><label>Min</label><input type="number" v-model.number="w.min" /></div>
                      <div class="ed-field"><label>Max</label><input type="number" v-model.number="w.max" /></div>
                      <div class="ed-field"><label>Step</label><input type="number" v-model.number="w.step" step="0.01" /></div>
                      <div class="ed-field"><label>Obligatorio</label><div class="ed-toggle" :class="{on:w.required}" @click="$set(w,'required',!w.required)">{{ w.required?'Si':'No' }}</div></div>
                    </div>
                    <div v-if="['select','radioCard','togglePair','levelSelector'].indexOf(w.tipo)>=0" class="ed-opts">
                      <label>Opciones</label>
                      <div class="ed-opt" v-for="(o,oi) in (w.options||[])" :key="'o'+oi">
                        <input type="text" v-model="o.key" placeholder="clave" style="width:60px" />
                        <input type="text" v-model="o.label" placeholder="etiqueta" style="flex:1" />
                        <input type="text" v-model="o.icono" placeholder="icono" style="width:40px" />
                        <input v-if="w.tipo==='levelSelector'" type="text" v-model="o.color" placeholder="#color" style="width:70px" />
                        <button class="ed-btn-mini ed-del" @click="delOption(w,oi)">✕</button>
                      </div>
                      <button class="ed-btn ed-btn-sm" @click="addOption(w)">+ Opcion</button>
                    </div>
                    <div class="ed-row">
                      <div class="ed-field ed-field-full">
                        <label>Visible si</label>
                        <div class="ed-cond">
                          <select v-model="w._visCampo"><option value="">Siempre</option><option v-for="cf in allCampos" :key="cf" :value="cf">{{ cf }}</option></select>
                          <select v-if="w._visCampo" v-model="w._visOp"><option value="===">igual a</option><option value="!==">distinto de</option></select>
                          <input v-if="w._visCampo" type="text" v-model="w._visVal" placeholder="valor" style="width:100px" />
                          <button v-if="w._visCampo" class="ed-btn-mini" @click="applyVisibleWidget(w)">Aplicar</button>
                          <span v-if="w.visible" class="ed-vis-tag">{{ w.visible }}</span>
                        </div>
                      </div>
                    </div>
                    <button class="ed-btn ed-btn-sm" @click="editingWidget=null">Cerrar edicion</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- TAB 4: SUBTIPOS -->
        <div v-if="activeTab==='subtipos'" class="ed-panel">
          <div class="ed-section">
            <div class="ed-row">
              <div class="ed-field">
                <label>Tiene subtipos</label>
                <div class="ed-toggle" :class="{on:hasSubtipos}" @click="toggleSubtipos">{{ hasSubtipos?'Si':'No' }}</div>
              </div>
              <div class="ed-field" v-if="hasSubtipos">
                <label>Campo selector</label>
                <select v-model="editing.subtipos.campo"><option v-for="cf in radioSelectCampos" :key="cf" :value="cf">{{ cf }}</option></select>
              </div>
            </div>
          </div>
          <div v-if="hasSubtipos">
            <div class="ed-section-top">
              <h3 class="ed-sh">Subtipos ({{ subtipoKeys.length }})</h3>
              <button class="ed-btn ed-btn-p" @click="addSubtipo">+ Subtipo</button>
            </div>
            <div class="ed-sec-card" v-for="sk in subtipoKeys" :key="sk">
              <div class="ed-sec-header" style="background:#1a2744">
                <span>{{ editing.subtipos.opciones[sk].icono||'' }} {{ sk }} — {{ editing.subtipos.opciones[sk].nombre }}</span>
                <button class="ed-btn-mini ed-del" @click="delSubtipo(sk)">✕</button>
              </div>
              <div class="ed-sec-body">
                <div class="ed-row">
                  <div class="ed-field"><label>Nombre</label><input type="text" v-model="editing.subtipos.opciones[sk].nombre" /></div>
                  <div class="ed-field"><label>Icono</label><input type="text" v-model="editing.subtipos.opciones[sk].icono" style="width:50px" /></div>
                  <div class="ed-field"><label>Norma</label><input type="text" v-model="editing.subtipos.opciones[sk].norma" /></div>
                </div>
                <div class="ed-row">
                  <div class="ed-field ed-field-full"><label>Descripcion</label><textarea v-model="editing.subtipos.opciones[sk].descripcion" rows="2"></textarea></div>
                </div>
                <div class="ed-params">
                  <label>Parametros de formula <span class="ed-hint">clave=valor, usados como params.X</span></label>
                  <div class="ed-param-row" v-for="(pv,pk) in (editing.subtipos.opciones[sk].params||{})" :key="pk">
                    <input type="text" :value="pk" disabled class="ed-pk" />
                    <input type="number" v-model.number="editing.subtipos.opciones[sk].params[pk]" step="0.001" />
                    <button class="ed-btn-mini ed-del" @click="delParam(sk,pk)">✕</button>
                  </div>
                  <div class="ed-param-add">
                    <input type="text" v-model="newParamKey" placeholder="clave" style="width:80px" />
                    <input type="number" v-model.number="newParamVal" placeholder="valor" style="width:80px" />
                    <button class="ed-btn ed-btn-sm" @click="addParam(sk)">+ Param</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- TAB 5: FORMULAS -->
        <div v-if="activeTab==='formulas'" class="ed-panel">
          <div class="ed-section">
            <h3 class="ed-sh">Formula TPC (Tiempo en Campo)</h3>
            <div class="ed-formula-builder">
              <div class="ed-formula-chips">
                <span class="ed-chip" v-for="cf in allCampos" :key="'fc'+cf" @click="insertFormula('tpc','form.'+cf)">{{ cf }}</span>
                <span class="ed-chip ed-chip-param" v-for="pk in paramKeys" :key="'fp'+pk" @click="insertFormula('tpc','params.'+pk)">params.{{ pk }}</span>
                <span class="ed-chip ed-chip-op" v-for="op in ops" :key="'o'+op" @click="insertFormula('tpc',op)">{{ op }}</span>
              </div>
              <textarea :value="formulaTpc" @input="escribirFormula('tpc', $event.target.value)" rows="3" class="ed-formula-input" placeholder="ej: params.base + (form.C || 1) * params.C"></textarea>
              <div class="ed-formula-preview"><span>Preview: TPC = </span><b>{{ testTpc }}</b><span> min</span></div>
              <div v-if="previaDelPrimerCaso" class="ed-formula-preview ed-previa-caso">
                <span>Con el caso «{{ previaDelPrimerCaso.nombre }}» y lo que hay en pantalla: TPC = </span><b>{{ previaDelPrimerCaso.tpc }}</b>
              </div>
            </div>
          </div>
          <div class="ed-section">
            <h3 class="ed-sh">Formula TPI (Tiempo en Oficina)</h3>
            <div class="ed-row">
              <div class="ed-field">
                <label>Modo</label>
                <select :value="tpiMode" @change="cambiarModoTpi($event.target.value)">
                  <option value="pct">TPC x TPI% (automatico)</option>
                  <option value="custom">Formula custom</option>
                </select>
              </div>
            </div>
            <div v-if="tpiMode==='pct'" class="ed-formula-preview" style="margin-top:8px">
              <span>TPI = TPC x {{ cfgTpiPct }}% = </span><b>{{ testTpi }}</b><span> min</span>
            </div>
            <div v-else>
              <textarea :value="formulaTpi" @input="escribirFormula('tpi', $event.target.value)" rows="2" class="ed-formula-input" placeholder="tpc * 0.12"></textarea>
              <div class="ed-formula-preview"><span>Preview: TPI = </span><b>{{ testTpi }}</b><span> min</span></div>
            </div>
            <div v-if="previaDelPrimerCaso" class="ed-formula-preview ed-previa-caso" style="margin-top:8px">
              <span>Con el caso «{{ previaDelPrimerCaso.nombre }}» y lo que hay en pantalla: TPI = </span><b>{{ previaDelPrimerCaso.tpi }}</b>
            </div>
          </div>
        </div>

        <!-- TAB 6: ALERTAS -->
        <div v-if="activeTab==='alertas'" class="ed-panel">
          <div class="ed-section-top">
            <h3 class="ed-sh">Alertas condicionales</h3>
            <button class="ed-btn ed-btn-p" @click="addAlerta">+ Alerta</button>
          </div>
          <div class="ed-sec-card" v-for="(al,ai) in (editing.alertas||[])" :key="'al'+ai">
            <div class="ed-sec-body">
              <div class="ed-row">
                <div class="ed-field">
                  <label>Condicion</label>
                  <div class="ed-cond">
                    <select v-model="al._campo"><option value="">Campo...</option><option v-for="cf in allCampos" :key="cf" :value="cf">{{ cf }}</option></select>
                    <select v-if="al._campo" v-model="al._op"><option value="<">menor que</option><option value=">">mayor que</option><option value="===">igual a</option><option value="!==">distinto</option></select>
                    <input v-if="al._campo" type="text" v-model="al._val" placeholder="valor" style="width:80px" />
                    <button v-if="al._campo" class="ed-btn-mini" @click="applyAlertaCond(al)">Aplicar</button>
                    <span v-if="al.condicion" class="ed-vis-tag">{{ al.condicion }}</span>
                  </div>
                </div>
              </div>
              <div class="ed-row">
                <div class="ed-field ed-field-full"><label>Mensaje</label><input type="text" v-model="al.mensaje" placeholder="Texto del aviso" /></div>
              </div>
              <div class="ed-row">
                <div class="ed-field">
                  <label>Tipo</label>
                  <select v-model="al.tipo"><option value="warn">Aviso amarillo</option><option value="error">Error rojo</option><option value="info">Info azul</option></select>
                </div>
                <div class="ed-field"><button class="ed-btn ed-btn-sm ed-del-btn" @click="delAlerta(ai)">Eliminar alerta</button></div>
              </div>
            </div>
          </div>
        </div>

        <!-- TAB 7: CASOS DE PRUEBA (#1185) -->
        <div v-if="activeTab==='casos'" class="ed-panel">
          <div class="ed-section-top">
            <h3 class="ed-sh">Casos de prueba</h3>
            <button class="ed-btn ed-btn-p" @click="addCaso">+ Caso</button>
          </div>
          <p class="ed-casos-intro">Cada caso calcula con lo que hay ahora en pantalla, sin guardar. Al pulsar «Guardar», si algún caso deja de dar lo esperado, se avisa antes de publicar y se puede cancelar.</p>
          <!-- Junto a los casos y no en un aviso de cabecera: es lo que impide calcularlos (reglas de
               pantalla de direccion, 05/10/2026). -->
          <div v-if="tieneCasos && estadoCfgCasos==='leyendo'" class="ed-casos-aviso">Leyendo la Configuración global de tarifas para calcular los casos…</div>
          <div v-if="tieneCasos && estadoCfgCasos==='error'" class="ed-casos-aviso ed-casos-aviso-mal">
            No se pueden calcular los casos: no se ha podido leer la Configuración global de tarifas (precio hora, km, dietas). Si sigue fallando, avisa a quien administra Tarifas · Configuración global.
            <button class="ed-btn ed-btn-sm" @click="asegurarConfigCasos(true)">Reintentar</button>
          </div>
          <p v-if="!tieneCasos" class="ed-casos-vacio">Esta herramienta no tiene casos de prueba. Sin casos, se guarda como siempre.</p>
          <div class="ed-sec-card" v-for="(caso,ci) in (editing.casosPrueba||[])" :key="'caso'+ci">
            <div class="ed-sec-header" style="background:#1a2744">
              <span>{{ nombreDelCaso(ci) }}</span>
              <div>
                <span class="ed-caso-estado" :class="'ed-caso-' + estadoDelCaso(ci).clase">{{ estadoDelCaso(ci).texto }}</span>
                <button class="ed-btn-mini ed-del" @click="delCaso(ci)">✕</button>
              </div>
            </div>
            <div class="ed-sec-body">
              <div class="ed-row">
                <div class="ed-field ed-field-full"><label>Nombre del caso <span class="ed-hint">de dónde sale: Excel, oferta…</span></label><input type="text" :value="caso.nombre" @input="$set(caso,'nombre',$event.target.value)" placeholder="Pública, 3 cuadros, 40 km" /></div>
              </div>
              <div class="ed-campos-header"><b>Datos de entrada</b></div>
              <div class="ed-row">
                <div class="ed-field" v-if="hasSubtipos">
                  <label>Subtipo</label>
                  <select :value="(caso.form||{}).srv" @change="setDatoCaso(caso,'srv',$event.target.value,'texto')">
                    <option value="">{{ sinTeclearCaso(caso, 'srv') }}</option>
                    <option v-for="sk in subtipoKeys" :key="'cs'+sk" :value="sk">{{ editing.subtipos.opciones[sk].nombre || sk }}</option>
                  </select>
                </div>
                <div class="ed-field" :class="{ 'ed-field-full': w.filas }" v-for="w in camposDeEntrada" :key="'ci'+ci+w.campo">
                  <label>{{ w.label || w.campo }}</label>
                  <!-- Tabla de casillas: la calculadora guarda un objeto { fila: true }, no un número. -->
                  <div v-if="w.filas" class="ed-caso-filas">
                    <label v-for="row in w.filas" :key="'cf'+ci+w.campo+row.key"><input type="checkbox" :checked="filaMarcadaCaso(caso,w.campo,row.key)" @change="setFilaCaso(caso,w.campo,row.key,$event.target.checked)" style="width:auto" /> {{ row.label || row.key }}</label>
                    <span v-if="!w.filas.length" class="ed-hint">La tabla no tiene filas definidas.</span>
                  </div>
                  <select v-else-if="w.opciones" :value="(caso.form||{})[w.campo]" @change="setDatoCaso(caso,w.campo,$event.target.value,'texto')">
                    <option value="">{{ sinTeclearCaso(caso, w.campo) }}</option>
                    <option v-for="o in w.opciones" :key="'co'+o.key" :value="o.key">{{ o.label || o.key }}</option>
                  </select>
                  <input v-else-if="w.esCasilla" type="checkbox" :checked="casillaDelCaso(caso,w.campo)" @change="setDatoCaso(caso,w.campo,$event.target.checked,'casilla')" style="width:auto" />
                  <input v-else type="number" :value="(caso.form||{})[w.campo]" :placeholder="porDefectoCaso(caso,w.campo)" @input="setDatoCaso(caso,w.campo,$event.target.value,'numero')" />
                </div>
                <div class="ed-field">
                  <label>Km de desplazamiento</label>
                  <input type="number" :value="(caso.form||{}).km" :placeholder="porDefectoCaso(caso,'km')" @input="setDatoCaso(caso,'km',$event.target.value,'numero')" min="0" />
                </div>
              </div>
              <div class="ed-params">
                <label>Otros datos <span class="ed-hint">campos que la calculadora pide y no salen arriba (clave = valor)</span></label>
                <div class="ed-param-row" v-for="k in otrosDatosDe(caso)" :key="'od'+ci+k">
                  <input type="text" :value="k" disabled class="ed-pk" />
                  <input type="text" :value="String(caso.form[k])" @input="setDatoCaso(caso,k,$event.target.value,'libre')" />
                  <button class="ed-btn-mini ed-del" @click="setDatoCaso(caso,k,'','libre')">✕</button>
                </div>
                <div class="ed-param-add">
                  <input type="text" v-model="nuevoDatoClave" placeholder="clave" style="width:80px" />
                  <input type="text" v-model="nuevoDatoValor" placeholder="valor" style="width:80px" />
                  <button class="ed-btn ed-btn-sm" @click="addOtroDato(caso)">+ Dato</button>
                </div>
              </div>
              <table class="ed-caso-tabla">
                <thead><tr><th>Resultado</th><th>Esperado</th><th>Con lo que hay en pantalla</th></tr></thead>
                <tbody>
                  <tr v-for="r in resultadosDelCaso" :key="'cr'+ci+r.clave" :class="{ 'ed-caso-fila-mal': diferenciaDe(ci, r.clave) }">
                    <td>{{ r.etiqueta }}</td>
                    <td><input :type="r.tipo==='texto' ? 'text' : 'number'" :step="r.tipo==='eur' ? '0.01' : '1'" :value="(caso.esperado||{})[r.clave]" @input="setEsperadoCaso(caso,r,$event.target.value)" /></td>
                    <td>{{ obtenidoDelCaso(ci, r) }}<span v-if="diferenciaDe(ci, r.clave)" class="ed-caso-cuanto"> ({{ cuantoDe(ci, r.clave) }})</span></td>
                  </tr>
                </tbody>
              </table>
              <p v-if="errorDelCaso(ci)" class="ed-casos-aviso ed-casos-aviso-mal">No se ha podido calcular: {{ errorDelCaso(ci) }}.</p>
              <button class="ed-btn ed-btn-sm" :disabled="!puedeTomarComoEsperado(ci)" @click="usarResultadoComoEsperado(ci)">Usar el resultado actual como esperado</button>
              <p v-if="!puedeTomarComoEsperado(ci) && estadoCfgCasos!=='ok'" class="ed-nodup">Se podrá usar cuando se haya leído la Configuración global de tarifas.</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </f7-page>
</template>

<script>
import TarifaHerramienta from './../../js/db/TarifaHerramienta.js';
import edicionDeLaFicha from './../../js/utils/edicionDeLaFicha.js';
import HelpButton from './../../components/HelpButton.vue';
import Tarifa from './../../js/db/Tarifa.js';
import TarifaCasosPrueba from './tarifa-casos-prueba.js';

const HELP_EDITOR = '<h3>Que es el Editor de Herramientas?</h3><p>El Editor te permite crear, modificar y duplicar las herramientas de calculo de tarifas que usa tu equipo comercial e inspector. Cada herramienta define como se calcula el precio de un tipo de inspeccion.</p><h3>Pantalla principal - Lista</h3><ul><li><b>+ Nueva herramienta:</b> Crea una herramienta desde cero</li><li><b>Editar:</b> Modifica una herramienta existente</li><li><b>Duplicar:</b> Crea una copia para modificar sin afectar la original</li><li>El badge verde "Activo" indica que la herramienta esta disponible para los usuarios</li></ul><h3>Pestana 1 - General</h3><ul><li><b>Codigo:</b> Identificador unico (solo al crear, no se puede cambiar despues). Ejemplo: rebt, ae, gasol</li><li><b>Nombre:</b> Nombre completo que veran los usuarios. Ejemplo: "REBT - Baja Tension"</li><li><b>Familia:</b> Categoria de la herramienta (Electrico, Mecanico, Termico, etc.)</li><li><b>Icono:</b> Selecciona un emoji representativo</li><li><b>Subtitulo:</b> Descripcion breve con la normativa aplicable</li><li><b>Norma:</b> Referencia normativa (RD, ITC, UNE, etc.)</li><li><b>Activo:</b> Si esta desactivado, la herramienta no aparece en el selector</li><li><b>Orden:</b> Posicion en el selector (1 = primero)</li></ul><h3>Pestana 2 - Configuracion de calculo</h3><ul><li><b>TPI %:</b> Porcentaje de Tiempo de Preparacion de Informe sobre el TPC. Ejemplo: 12% significa que TPI = TPC x 0.12</li><li><b>Tiene 2a inspeccion:</b> Si la herramienta calcula precio de segunda inspeccion (las Lineas de Vida no tienen 2a)</li><li><b>Factor 2a TPC:</b> Porcentaje del TPC que se aplica en la segunda inspeccion. 0.4 = 40%</li><li><b>Factor 2a TPI:</b> Igual para el TPI de la segunda inspeccion</li><li><b>Km minimos:</b> Kilometraje minimo para esta herramienta. Si se deja vacio, usa el valor global (60 km)</li></ul><h3>Pestana 3 - Secciones y campos</h3><p>Aqui defines el formulario que vera el usuario al usar la herramienta.</p><ul><li><b>+ Seccion:</b> Anade un bloque visual (card) con su titulo y color</li><li><b>Color:</b> Color del encabezado de la seccion (Azul oscuro, Verde, Azul, Gris, Marron)</li><li><b>Columnas:</b> Cuantos campos se muestran por fila (2, 3, 4 o 5)</li><li><b>Visible si:</b> Condicion para mostrar la seccion. Ejemplo: solo mostrar "Elementos CT" si el campo "modo" es igual a "ct"</li><li><b>Flechas:</b> Reordena secciones</li></ul><p><b>Tipos de campo disponibles:</b></p><ul><li><b>Numero:</b> Campo numerico (cuadros, superficie, km, etc.)</li><li><b>Checkbox:</b> Casilla de verificacion (Autolavado, Cab.Pintura, etc.)</li><li><b>Selector:</b> Lista desplegable con opciones</li><li><b>Radio cards:</b> Tarjetas seleccionables con icono (tipos de instalacion)</li><li><b>Toggle par:</b> Dos botones excluyentes (RIPCI/RSCIEI, Con/Sin desplazamiento)</li><li><b>Nivel riesgo:</b> Selector con colores (Bajo verde, Medio amarillo, Alto rojo)</li><li><b>Checkbox con sub-input:</b> Checkbox que al activar muestra un campo adicional (m2 rociadores)</li><li><b>Tabla checkboxes:</b> Tabla con filas activables (sistemas PCI)</li></ul><h3>Pestana 4 - Subtipos</h3><p>Los subtipos permiten que una herramienta tenga variantes con diferentes parametros de calculo.</p><ul><li><b>Ejemplo REBT:</b> Tiene 6 subtipos (Publica Concurrencia, Industrias, Piscinas, Alumbrado, Talleres, Riesgo Incendio), cada uno con sus propios valores de base, C, F, G, etc.</li><li><b>Campo selector:</b> Que campo del formulario controla el subtipo activo (normalmente "srv")</li><li><b>Parametros:</b> Valores numericos que se usan en la formula. Ejemplo: base=30, C=20 -> la formula usa params.base + form.C x params.C</li></ul><h3>Pestana 5 - Formulas</h3><p>Define como se calcula el tiempo de inspeccion.</p><ul><li><b>Chips azules:</b> Campos del formulario (form.C, form.km, etc.). Haz click para insertarlos</li><li><b>Chips verdes:</b> Parametros de los subtipos (params.base, params.C, etc.)</li><li><b>Chips grises:</b> Operadores matematicos (+, -, x, /, parentesis)</li><li><b>Preview:</b> Muestra el resultado con valores de ejemplo para verificar</li><li><b>TPI automatico:</b> Se calcula como TPC x TPI%. Solo usa formula custom si necesitas algo especial</li></ul><h3>Pestana 6 - Alertas</h3><p>Avisos que aparecen al usuario cuando introduce datos fuera de rango.</p><ul><li><b>Ejemplo:</b> Si "Cuadros" &lt; 2 y subtipo es "Piscinas", mostrar: "Piscinas: minimo 2 cuadros"</li><li><b>Tipos:</b> Aviso (amarillo), Error (rojo), Info (azul)</li></ul><h3>Pestana 7 - Casos de prueba</h3><p>Datos de entrada con los minutos e importes que tienen que salir (del Excel o de ofertas reales). Se calculan con lo que hay en pantalla, sin guardar, asi que sirven de vista previa de un cambio.</p><ul><li><b>+ Caso:</b> Anade un caso con sus datos de entrada</li><li><b>Esperado:</b> Lo que tiene que salir. Lo que se deja vacio no se comprueba</li><li><b>Usar el resultado actual como esperado:</b> Da por bueno lo que sale ahora, por ejemplo despues de una subida de tarifa decidida</li><li><b>Al guardar:</b> Si algun caso deja de dar lo esperado, se avisa con el caso, el valor esperado y el nuevo, y se puede cancelar sin publicar nada</li></ul><h3>Acciones</h3><ul><li><b>Guardar:</b> Guarda los cambios. Los usuarios veran la herramienta actualizada inmediatamente</li><li><b>Preview:</b> Abre el calculador con la version guardada de la herramienta. Lo que hay sin guardar se prueba en Casos de prueba</li><li><b>Cerrar:</b> Vuelve a la lista sin guardar</li></ul>';

export default {
  components: { HelpButton },
  data: function () {
    return {
      helpEditorHTML: HELP_EDITOR,
      herramientas: [],
      editing: null,
      isNew: false,
      activeTab: 'general',
      editingWidget: null,
      newParamKey: '',
      newParamVal: 0,
      motivo: '',
      cfgTpiPct: 12,
      cfgF2tpc: 0.4,
      cfgF2tpi: 0.4,
      cfgTiene2a: true,
      cfgKmmin: null,
      formulaTpc: '',
      formulaTpi: '',
      tpiMode: 'pct',
      // Que ha escrito la persona en esta ficha. Lo que solo se guarda si alguien lo escribio -la
      // `formula`, las raices apartadas, el `kmmin` propio- se decide preguntando aqui y NO
      // comparando lo que quedo en pantalla: el editor rellena las cajas con un neutro para poder
      // pintarlas, asi que escribir ese mismo neutro para reparar un dato invalido no se distingue
      // de no haber tocado nada (#387, revision del PR #1793). Ver `edicionDeLaFicha`.
      edicion: edicionDeLaFicha(),
      // Las raices de expresiones que llegaron con una forma que este editor no sabe pintar. Se
      // apartan para poder abrir la ficha y se devuelven intactas al guardar.
      raicesApartadas: {},
      hasSubtipos: false,
      // Los casos de prueba (#1185) se calculan con la configuracion global vigente, que se lee solo
      // cuando hay casos: una herramienta sin casos no hace ninguna peticion mas que antes.
      // `estadoCfgCasos`: 'sin-leer' | 'leyendo' | 'ok' | 'error'.
      cfgCasos: null,
      estadoCfgCasos: 'sin-leer',
      nuevoDatoClave: '',
      nuevoDatoValor: '',
      tabs: [
        { key: 'general', icon: '📝', label: 'General' },
        { key: 'config', icon: '⚙️', label: 'Config' },
        { key: 'secciones', icon: '📋', label: 'Secciones' },
        { key: 'subtipos', icon: '🔀', label: 'Subtipos' },
        { key: 'formulas', icon: '🧮', label: 'Formulas' },
        { key: 'alertas', icon: '⚠️', label: 'Alertas' },
        { key: 'casos', icon: '🧪', label: 'Casos de prueba' }
      ],
      familias: [
        { key: 'electrico', label: 'Electrico' }, { key: 'mecanico', label: 'Mecanico' }, { key: 'termico', label: 'Termico' },
        { key: 'presion', label: 'Presion' }, { key: 'petroliferas', label: 'Petroliferas' }, { key: 'incendios', label: 'Incendios' },
        { key: 'maquinas', label: 'Maquinas' }, { key: 'elevadores', label: 'Elevadores' }, { key: 'gruas', label: 'Gruas' },
        { key: 'estructuras', label: 'Estructuras' }, { key: 'otros', label: 'Otros' }
      ],
      emojis: ['⚡', '🏭', '🔥', '🌡️', '⛽', '🛗', '🏗️', '⚙️', '🪝', '📋', '🧯', '🔧', '💡', '🏊', '🔋', '🗼', '🔌', '☀️', '📦', '📄', '🚜', '🏘️', '📊'],
      colorMap: { navy: '#1a2744', green: '#166534', blue: '#1e3a5f', gray: '#374151', brown: '#92400e' },
      tipoLabels: { number: 'Num', checkbox: 'Check', select: 'Select', radioCard: 'Radio', togglePair: 'Toggle', levelSelector: 'Nivel', checkboxCard: 'ChkCard', tableCheckboxes: 'Tabla' },
      ops: [' + ', ' - ', ' * ', ' / ', ' ( ', ' ) ', ' || 0', ' ? 1 : 0']
    };
  },
  computed: {
    allCampos: function () {
      var campos = ['srv'];
      if (this.editing && this.editing.secciones) {
        this.editing.secciones.forEach(function (s) {
          if (s.widgets) s.widgets.forEach(function (w) { if (w.campo && campos.indexOf(w.campo) < 0) campos.push(w.campo); });
        });
      }
      return campos;
    },
    radioSelectCampos: function () {
      var campos = ['srv'];
      if (this.editing && this.editing.secciones) {
        this.editing.secciones.forEach(function (s) {
          if (s.widgets) s.widgets.forEach(function (w) {
            if (['radioCard', 'select', 'togglePair', 'levelSelector'].indexOf(w.tipo) >= 0 && w.campo) campos.push(w.campo);
          });
        });
      }
      return campos;
    },
    subtipoKeys: function () {
      if (!this.editing || !this.editing.subtipos || !this.editing.subtipos.opciones) return [];
      return Object.keys(this.editing.subtipos.opciones);
    },
    paramKeys: function () {
      if (!this.editing || !this.editing.subtipos || !this.editing.subtipos.opciones) return [];
      var keys = {};
      var opc = this.editing.subtipos.opciones;
      Object.keys(opc).forEach(function (sk) { if (opc[sk].params) Object.keys(opc[sk].params).forEach(function (pk) { keys[pk] = true; }); });
      return Object.keys(keys);
    },
    testTpc: function () {
      try {
        var form = { C: 1, n: 1, srv: 'test' };
        var params = { base: 30, C: 20, tpi: 0.12 };
        return Math.round(new Function('form', 'params', 'return ' + this.formulaTpc)(form, params) * 100) / 100;
      } catch (e) { return 'Error'; }
    },
    tieneCasos: function () {
      return TarifaCasosPrueba.tieneCasos(this.editing);
    },
    /**
     * Los casos, calculados con la definicion que hay en pantalla: la misma que se enviaria al pulsar
     * «Guardar» (`syncToEditing`), no la version guardada. Es la vista previa de verdad.
     *
     * Se leen antes, una a una, las cajas que `syncToEditing` solo mira a veces: la `formula` y el
     * `kmmin` entran en el envio segun lo que `edicionDeLaFicha` haya anotado, y esa anotacion no es
     * reactiva. Sin leerlas aqui, el primer cambio en una formula no recalcularia los casos.
     */
    definicionCasos: function () {
      if (!this.tieneCasos) return null;
      const reactivas = [this.formulaTpc, this.formulaTpi, this.tpiMode, this.cfgTpiPct, this.cfgF2tpc,
        this.cfgF2tpi, this.cfgTiene2a, this.cfgKmmin];
      return reactivas.length ? this.syncToEditing() : null;
    },
    resultadosCasos: function () {
      if (!this.definicionCasos || this.estadoCfgCasos !== 'ok') return [];
      return TarifaCasosPrueba.ejecutarCasos(this.definicionCasos, this.cfgCasos);
    },
    /** Los campos de las secciones con los que se teclea un caso: uno por nombre, como en la calculadora. */
    camposDeEntrada: function () {
      const vistos = {};
      const salida = [];
      const secciones = Array.isArray(this.editing && this.editing.secciones) ? this.editing.secciones : [];
      secciones.forEach(function (sec) {
        (Array.isArray(sec && sec.widgets) ? sec.widgets : []).forEach(function (w) {
          if (!w || !w.campo || w.campo === 'srv' || w.campo === 'km' || vistos[w.campo]) return;
          vistos[w.campo] = true;
          const conOpciones = ['select', 'radioCard', 'togglePair', 'levelSelector'].indexOf(w.tipo) >= 0 && Array.isArray(w.options);
          salida.push({
            campo: w.campo, label: w.label,
            opciones: conOpciones ? w.options : null,
            esCasilla: w.tipo === 'checkbox' || w.tipo === 'checkboxCard',
            filas: w.tipo === 'tableCheckboxes' ? (Array.isArray(w.rows) ? w.rows.filter(function (r) { return r && r.key; }) : []) : null
          });
        });
      });
      return salida;
    },
    /** Que resultados se pueden esperar: la clasificacion (AP) decide una categoria y no tiene precio. */
    resultadosDelCaso: function () {
      const clasificacion = !!(this.editing && this.editing.config && this.editing.config.modoCalculo === 'clasificacion');
      return TarifaCasosPrueba.RESULTADOS.filter(function (r) {
        return clasificacion ? r.clave === 'categoria' : r.clave !== 'categoria';
      });
    },
    /** El primer caso calculado, para que la pestaña de formulas enseñe algo mas que valores de ejemplo. */
    previaDelPrimerCaso: function () {
      const r = this.resultadosCasos[0];
      if (!r || !r.obtenido || r.obtenido.tpc === undefined) return null;
      const min = TarifaCasosPrueba.RESULTADOS[0];
      return {
        nombre: TarifaCasosPrueba.nombreDe(r, 0),
        tpc: TarifaCasosPrueba.formatear(min, r.obtenido.tpc),
        tpi: TarifaCasosPrueba.formatear(min, r.obtenido.tpi)
      };
    },
    testTpi: function () {
      var tpc = typeof this.testTpc === 'number' ? this.testTpc : 0;
      if (this.tpiMode === 'pct') return Math.round(tpc * this.cfgTpiPct / 100 * 100) / 100;
      try { return Math.round(new Function('form', 'params', 'tpc', 'return ' + this.formulaTpi)({}, {}, tpc) * 100) / 100; }
      catch (e) { return 'Error'; }
    }
  },
  mounted: function () { this.cargar(); },
  methods: {
    formatFechaEd: function(str) {
      if (!str) return '—';
      try { var d = new Date(str); return isNaN(d.getTime()) ? str : String(d.getDate()).padStart(2,'0')+'/'+String(d.getMonth()+1).padStart(2,'0')+'/'+d.getFullYear(); } catch(e) { return str; }
    },
    cargar: function () {
      var self = this;
      TarifaHerramienta.getList().then(function (l) { self.herramientas = l || []; }).catch(function () { self.herramientas = []; });
    },
    nuevaHerramienta: function () {
      this.isNew = true;
      this.edicion.fichaNueva();
      this.editing = { codigo: '', nombre: '', familia: 'electrico', icono: '⚡', subtitulo: '', norma: '', activo: true, orden: this.herramientas.length + 1, config: {}, subtipos: {}, secciones: [], formula: { tpc: '0', tpi: '0' }, alertas: [] };
      this.apartarRaicesQueNoSeSabePintar();
      this.syncFromEditing();
      this.activeTab = 'general';
    },
    editarHerramienta: function (h) {
      this.isNew = false;
      this.edicion.fichaNueva();
      this.editing = JSON.parse(JSON.stringify(h));
      this.apartarRaicesQueNoSeSabePintar();
      // Solo se rellena lo que NO viene. Lo que viene se respeta: ni se sintetiza encima ni se
      // sustituye por una lista vacia, porque eso es lo que le cambiaba el veredicto a
      // `TarifaHerramienta.retencion` (#387, revision del PR #1793). La `formula` no se sintetiza
      // nunca -ver `syncToEditing`- y las otras dos solo cuando faltan.
      if (!this.editing.secciones) this.editing.secciones = [];
      if (!this.editing.alertas) this.editing.alertas = [];
      if (!this.editing.subtipos) this.editing.subtipos = {};
      this.syncFromEditing();
      this.activeTab = 'general';
      if (TarifaCasosPrueba.tieneCasos(this.editing)) this.asegurarConfigCasos(false);
    },
    /**
     * Por que esta herramienta NO se puede duplicar, o `null` si se puede.
     *
     * POR QUE SE BLOQUEA EN VEZ DE AVISAR (#387, ronda 2 de la revision del PR #1793)
     *
     * Duplicar es un ALTA, y en un alta las claves de la configuracion global no se pueden conservar:
     * no hay predecesora de la que heredarlas y la API las rechaza como nuevas, asi que la copia sale
     * sin ellas (`TarifaHerramienta.sinClavesGlobales`). Si alguna expresion de la original las lee
     * —`params` ES el `config` de la herramienta en el calculador, ver `currentParams`—, la copia
     * calcula con `undefined`: `NaN` y, por el `(tpc || 0)`, cero.
     *
     * Aqui se avisaba al duplicar y se mandaba a comprobarlo con «Preview», y eso no protegia nada:
     * «Preview» navega al calculador del codigo nuevo, pero el calculador solo carga herramientas ya
     * guardadas y activas (`findAllActive`), asi que la copia sin guardar no se puede previsualizar; y
     * el clon hereda el `activo` de la original, asi que se podia guardar activa con el precio roto.
     *
     * Tampoco vale crear la copia inactiva: la lista de esta pantalla y la del calculador salen las
     * dos de `findAllActive`, asi que una copia inactiva no se veria en ningun sitio.
     *
     * Asi que no se duplica mientras arrastre el residuo y tenga expresiones, que es el mismo
     * criterio conservador que todo lo demas de esta tanda: no se lee la formula para decidir. Lo
     * desbloquea la limpieza revisada, y hasta entonces la ficha se puede crear desde cero.
     */
    motivoNoDuplicar: function (h) {
      const residuo = TarifaHerramienta.sinClavesGlobales(h);
      if (!residuo.retenida) return null;
      return 'No se puede duplicar: su configuracion arrastra valores que son de Configuracion global'
        + ' de tarifas (' + residuo.claves.join(', ') + ') y esta herramienta tiene formulas o'
        + ' condiciones propias. La copia se crearia sin esos valores y, si alguna de sus formulas los'
        + ' usara, su precio saldria mal sin avisar. Lo desbloquea la limpieza de tarifas revisada, que'
        + ' esta pendiente en la incidencia #387; mientras, se puede partir de «+ Nueva herramienta».';
    },
    duplicarHerramienta: function (h) {
      // El boton esta deshabilitado en ese caso: esto es para cualquier otro camino que llegue aqui.
      const bloqueo = this.motivoNoDuplicar(h);
      if (bloqueo) {
        this.$f7.dialog.alert(bloqueo, 'Duplicar herramienta');
        return;
      }
      this.isNew = true;
      this.edicion.fichaNueva();
      this.editing = JSON.parse(JSON.stringify(h));
      this.editing.codigo = h.codigo + '_copia';
      this.editing.nombre = h.nombre + ' (copia)';
      delete this.editing.id;
      delete this.editing._id;
      this.apartarRaicesQueNoSeSabePintar();
      this.syncFromEditing();
      this.activeTab = 'general';
      // La copia se lleva los casos de la original (#1185): se calculan igual que al editarla.
      if (TarifaCasosPrueba.tieneCasos(this.editing)) this.asegurarConfigCasos(false);
      this.avisarDelResiduoQueNoSeDuplica(h.nombre);
    },
    /**
     * Dice, al duplicar y no al guardar, que la copia se crea SIN los valores de la Configuracion
     * global que la original arrastre dentro de su `config`.
     *
     * Por que se dice y no se calla (#387, ronda de revision del PR #1793): duplicar es un alta, y en
     * un alta esas claves no se pueden conservar —no hay predecesora de la que heredarlas y la API las
     * rechaza como nuevas, ver `TarifaHerramienta.sinClavesGlobales`—, asi que la copia sale limpia y
     * la original no. Las 19 vigentes arrastran la copia del volcado, asi que esto sale en cuanto
     * alguien duplica cualquiera de ellas.
     *
     * Aqui ya se sabe que no hay nada que pueda leerlos: si la original tuviera formulas, condiciones
     * o visibilidad propias no se habria llegado a duplicar (`motivoNoDuplicar`). Asi que el precio de
     * la copia no cambia, y esto no manda a comprobar nada —mandaba a comprobarlo con «Preview», que
     * no puede previsualizar una copia sin guardar (ronda 2 de la revision del PR #1793)—: solo dice
     * que la copia sale distinta de la original, que es lo que no se puede callar.
     *
     * Las claves las enumera `sinClavesGlobales`, que es el unico sitio donde esta ese criterio: aqui
     * ya no hay `id`, asi que contesta lo que de verdad va a pasar en el guardado.
     */
    avisarDelResiduoQueNoSeDuplica: function (nombre) {
      const quitadas = TarifaHerramienta.sinClavesGlobales(this.editing).quitadas;
      if (!quitadas.length) return;
      this.$f7.dialog.alert('La copia se crea SIN los valores de Configuracion global de tarifas que '
        + (nombre || 'la herramienta') + ' arrastra dentro de su configuracion (' + quitadas.join(', ')
        + '). Al crear una herramienta nueva esos valores no se pueden copiar, y el calculo los lee de'
        + ' Configuracion global de tarifas, no de la herramienta. Esta herramienta no tiene formulas'
        + ' ni condiciones propias que pudieran usarlos, asi que la copia calcula lo mismo. La'
        + ' herramienta original se queda como esta.', 'Duplicar herramienta');
    },
    /**
     * Aparta las raices de expresiones que llegaron con una forma que este editor no sabe pintar
     * -un `secciones` que es un numero: `v-for` pintaria basura y `allCampos` reventaria- y les deja
     * una lista vacia en su sitio. Se devuelven tal cual al guardar (`devolverRaicesApartadas`).
     *
     * Quien decide si una raiz es editable es `TarifaHerramienta.formaDeLaRaiz`, no esta pantalla:
     * tener aqui un segundo criterio es exactamente lo que hacia que el editor cambiara sin querer lo
     * que `TarifaHerramienta.retencion` iba a contestar (#387).
     */
    apartarRaicesQueNoSeSabePintar: function () {
      const self = this;
      self.raicesApartadas = {};
      TarifaHerramienta.RAICES_DE_EXPRESIONES.forEach(function (raiz) {
        // La `formula` no se pinta en una lista: tiene sus dos cajas, y no hay que apartarla porque
        // nadie la pisa -`syncToEditing` trabaja sobre una copia-, asi que se conserva entera venga
        // como venga.
        if (raiz === 'formula') return;
        if (TarifaHerramienta.formaDeLaRaiz(self.editing[raiz], raiz) !== TarifaHerramienta.INTOCABLE) return;
        self.raicesApartadas[raiz] = self.editing[raiz];
        self.$set(self.editing, raiz, []);
      });
    },
    syncFromEditing: function () {
      const cfg = this.editing.config || {};
      this.cfgTpiPct = Math.round((cfg.tpi_pct || 0.12) * 100);
      this.cfgF2tpc = cfg.f2tpc || 0.4;
      this.cfgF2tpi = cfg.f2tpi || 0.4;
      this.cfgTiene2a = cfg.tiene2a !== false;
      // El cero es un override como cualquier otro, aqui y al guardar (ronda 2 de la revision del PR
      // #1793): el criterio del calculador es `typeof cfgH.kmmin === 'number'` (`kmminEfectivo`), asi
      // que un `kmmin: 0` guardado SE COBRA —no hay minimo— y con `cfg.kmmin || null` la caja se
      // abria vacia, como si la herramienta no tuviera override. El `isFinite` deja fuera lo que el
      // calculador no sabria usar.
      this.cfgKmmin = this.kmminDeLaCaja(cfg.kmmin);
      // La `formula` se LEE y NO se da por hecha: ni la hay en la version 1 de casi todas las
      // herramientas, ni la sintetiza ya `editarHerramienta`, ni tiene que ser un contenedor
      // -`duplicarHerramienta` reventaba con un TypeError sobre `.formula.tpc`-. Las dos cajas de la
      // pantalla se rellenan solo si se puede leer dentro, y lo que vino se queda donde esta.
      const formula = TarifaHerramienta.formaDeLaRaiz(this.editing.formula, 'formula') === TarifaHerramienta.EDITABLE
        ? this.editing.formula : {};
      // `String(...)` porque una expresion tambien puede venir como numero -`{tpi: 7}` es una
      // expresion constante para el calculador- y el `indexOf` de aqui abajo reventaria.
      this.formulaTpc = String(formula.tpc || '0');
      this.formulaTpi = String(formula.tpi || '0');
      this.hasSubtipos = !!(this.editing.subtipos && this.editing.subtipos.opciones && Object.keys(this.editing.subtipos.opciones).length);
      const tpiExpr = this.formulaTpi;
      this.tpiMode = (tpiExpr.indexOf('tpc') >= 0 && tpiExpr.indexOf('*') >= 0 && tpiExpr.length < 30) ? 'pct' : 'custom';
    },
    /**
     * Los manejadores de las cajas que escriben la `formula` y el `kmmin` propio. Existen -en vez de
     * un `v-model` a secas- porque son el sitio donde se ANOTA que la persona ha escrito: es lo
     * unico que distingue «ha dejado un 0» de «el editor pinto un 0 para poder abrir la ficha», y
     * sin esa anotacion una herramienta con una `formula` invalida no se puede reparar (#387,
     * revision del PR #1793). Ver `edicionDeLaFicha`.
     */
    escribirFormula: function (caja, texto) {
      if (caja === 'tpc') this.formulaTpc = texto;
      else this.formulaTpi = texto;
      this.edicion.anota('formula');
    },
    cambiarModoTpi: function (modo) {
      this.tpiMode = modo;
      this.edicion.anota('formula');
    },
    cambiarTpiPct: function (valor) {
      this.cfgTpiPct = Number(valor);
      // En modo `pct` el porcentaje ES la expresion del TPI (`expresionTpi`), asi que moverlo es
      // escribir la formula. En modo `custom` no entra en ninguna expresion: solo es `config.tpi_pct`,
      // que se guarda siempre.
      if (this.tpiMode === 'pct') this.edicion.anota('formula');
    },
    escribirKmmin: function (valor) {
      this.cfgKmmin = this.kmminDeLaCaja(valor);
      this.edicion.anota('kmmin');
    },
    /**
     * El `kmmin` que de verdad hay en una caja o en un `config`: un numero utilizable, o `null` si no
     * hay override.
     *
     * Esta en un sitio y lo usan los tres —leer la ficha, escribir la caja y preparar el envio—
     * porque la distincion que importa es la que se confundia: `null` es «no hay override» y `0` es
     * «override de cero kilometros minimos», que el control admite (`min="0"`) y el calculador cobra
     * (`kmminEfectivo` acepta cualquier numero). Con un `if (valor)` por medio el cero salia por la
     * misma rama que la caja vacia y el override desaparecia, asi que el desplazamiento volvia a
     * cobrarse con el minimo global.
     */
    kmminDeLaCaja: function (valor) {
      if (valor === '' || valor === null || valor === undefined) return null;
      const numero = Number(valor);
      return isFinite(numero) ? numero : null;
    },
    /** La expresion de TPI que corresponde a lo que hay en pantalla, en los dos modos. */
    expresionTpi: function () {
      return this.tpiMode === 'pct' ? 'tpc * ' + (this.cfgTpiPct / 100) : this.formulaTpi;
    },
    /**
     * Construye lo que se va a guardar. **No toca `this.editing`**, que es el estado vivo de la ficha
     * abierta.
     *
     * Preparar el envio mutando `editing` es lo que rompia el reintento, y es la forma del fallo, no
     * un caso suelto (#387, revision del PR #1793): un guardado puede fallar -una red que se cae, un
     * 5xx- y la ficha se queda abierta tal como la dejo el intento anterior, asi que el segundo
     * intento ya no parte de donde partio el primero. Por ahi se iban tres cosas, y solo la primera
     * estaba señalada:
     *
     * - la `formula` que vino quedaba pisada con el primer cambio, y entonces volver las cajas a su
     *   valor inicial y reintentar guardaba ese primer cambio igualmente, distinto de lo que la
     *   pantalla enseñaba;
     * - la raiz que `apartarRaicesQueNoSeSabePintar` habia apartado volvia VIVA a la ficha, asi que
     *   `allCampos` hacia `forEach` sobre un numero y reventaba la pantalla que el apartado existe
     *   justo para poder pintar;
     * - y el `motivo` aparecia escrito en la cabecera de versiones sin que nadie lo hubiera escrito.
     *
     * Sobre una copia no pasa ninguna de las tres, y no hace falta guardar aparte lo que vino: la
     * copia lo trae intacto.
     */
    syncToEditing: function () {
      const aEnviar = JSON.parse(JSON.stringify(this.editing));
      if (!aEnviar.config) aEnviar.config = {};
      aEnviar.config.tpi_pct = this.cfgTpiPct / 100;
      aEnviar.config.f2tpc = this.cfgF2tpc;
      aEnviar.config.f2tpi = this.cfgF2tpi;
      aEnviar.config.tiene2a = this.cfgTiene2a;
      // El `kmmin` propio de la herramienta: se escribe si la persona ha tocado su caja, y entonces
      // vaciarla QUITA el override -antes el `if (this.cfgKmmin)` leia la caja vacia como «no la ha
      // tocado» y devolvia el valor que vino, asi que desde la pantalla no se podia retirar: es la
      // misma forma del fallo que la `formula` de aqui abajo (#387)-. Es el unico valor de la copia
      // que el calculador lee de verdad de la herramienta (`kmminEfectivo`), asi que no tocarlo
      // cuando nadie lo ha tocado importa: Ascensores mantiene el suyo por decision de direccion.
      if (this.edicion.laHaEscrito('kmmin')) {
        // `null` es la caja vacia y quita el override; cualquier numero, CERO INCLUIDO, es un
        // override: ver `kmminDeLaCaja`.
        if (this.cfgKmmin === null) delete aEnviar.config.kmmin;
        else aEnviar.config.kmmin = this.cfgKmmin;
      }
      if (this.edicion.laHaEscrito('formula')) {
        // Aqui si ha escrito alguien, asi que se escribe. Sobre el contenedor que vino, para no
        // perder lo que la pantalla no muestra, y sobre uno nuevo si lo que vino no era un
        // contenedor: `formula.tpc = ...` sobre un numero no guarda nada.
        if (TarifaHerramienta.formaDeLaRaiz(aEnviar.formula, 'formula') !== TarifaHerramienta.EDITABLE) {
          aEnviar.formula = {};
        }
        aEnviar.formula.tpc = this.formulaTpc;
        aEnviar.formula.tpi = this.expresionTpi();
      }
      // Y si no ha escrito nadie, con la `formula` no se hace NADA: la copia la trae EXACTAMENTE como
      // vino. Que no es lo mismo que mandar lo que hay en las cajas -el editor las rellena con '0'
      // para poder pintarlas, y reenviar ese '0' es inventar una expresion que nadie escribio: con
      // ella `TarifaHerramienta.retencion` ve una expresion -un '0' es una expresion constante y
      // retiene, a proposito- y frena el guardado de una herramienta que no tiene nada que pueda leer
      // las claves globales que arrastra, que es justo la que SI se puede limpiar-. No decidir caso
      // por caso cubre de una vez los cuatro que fueron saliendo uno por ronda de revision: no venia
      // ninguna, venia `{}`, venia `{tpc: '', tpi: ''}` -presente pero sin ninguna expresion
      // evaluable, asi que se puede limpiar- y venia con una forma que no es un contenedor, que hay
      // que conservar para que la retencion la vea y frene.
      //
      // Y «no ha escrito nadie» es lo que `edicionDeLaFicha` ANOTO, no lo que se deduzca de las
      // cajas: comparar el valor final con el relleno inicial dejaba sin reparacion posible una
      // `formula: 7` -la pantalla pinta '0' en las dos cajas, asi que escribir '0' para repararla
      // salia como «no ha tocado nada» y se le devolvia el 7-.
      this.devolverRaicesApartadas(aEnviar);
      aEnviar.motivo = this.motivo || 'Actualizacion';
      return aEnviar;
    },
    /**
     * Devuelve a lo que se envia las raices apartadas por `apartarRaicesQueNoSeSabePintar`, salvo que
     * la persona haya construido algo en su lugar: eso ultimo es un acto deliberado y manda.
     *
     * Si no se devolvieran, la lista vacia con la que se abrio la ficha se guardaria encima: la forma
     * que `retencion` tenia que ver como `DESCONOCIDA` -y retener- pasaria por «sin expresiones» y la
     * herramienta se limpiaria.
     *
     * Se devuelve un CLON, no el apartado: el apartado es el unico sitio donde queda lo que vino y
     * tiene que seguir intacto si el guardado falla y se reintenta.
     *
     * «Haber construido algo» se pregunta a `edicionDeLaFicha` y NO se mide por la longitud de la
     * lista (#387, revision del PR #1793): la lista vacia es tambien lo que el editor pinta en el
     * hueco de la raiz apartada, asi que con la longitud una persona que añade una seccion y la
     * borra -que es dejar la lista vacia a proposito, el estado natural al que hay que poder
     * repararla- salia como «no ha tocado nada» y se le devolvia la forma invalida.
     */
    devolverRaicesApartadas: function (aEnviar) {
      const self = this;
      Object.keys(self.raicesApartadas).forEach(function (raiz) {
        if (self.edicion.laHaEscrito(raiz)) return;
        aEnviar[raiz] = JSON.parse(JSON.stringify(self.raicesApartadas[raiz]));
      });
    },
    /**
     * Guarda, pero antes ejecuta los casos de prueba con lo que se va a enviar (#1185). Sin casos, se
     * guarda exactamente como antes: ni se lee la configuracion global ni se pregunta nada.
     *
     * Si algun caso deja de dar lo esperado, o no se ha podido calcular, se dice cual y cuanto y la
     * persona decide: «Cancelar» no publica nada y deja la ficha como estaba. No hay «aceptar los
     * valores nuevos» en bloque desde aqui: eso se hace caso por caso en su pestaña, que es donde se
     * ve lo que se esta dando por bueno.
     */
    guardar: function () {
      const self = this;
      const aEnviar = this.syncToEditing();
      if (!TarifaCasosPrueba.tieneCasos(aEnviar)) {
        this.enviar(aEnviar);
        return;
      }
      this.asegurarConfigCasos(true).then(function () {
        const cambios = TarifaCasosPrueba.cambios(TarifaCasosPrueba.ejecutarCasos(aEnviar, self.cfgCasos));
        if (!cambios.length) {
          self.enviar(aEnviar);
          return;
        }
        self.$f7.dialog.create({
          title: 'Hay casos de prueba que cambian',
          text: self.textoDelAvisoDeCasos(cambios),
          buttons: [
            { text: 'Cancelar' },
            { text: 'Publicar igualmente', bold: true, onClick: function () { self.enviar(aEnviar); } }
          ]
        }).open();
      });
    },
    /** El aviso del guardado: cada caso, que valor se esperaba, cual sale y cuanto se mueve. */
    textoDelAvisoDeCasos: function (cambios) {
      const esc = this.escaparHtml;
      const lineas = cambios.map(function (r) {
        const nombre = '<b>' + esc(TarifaCasosPrueba.nombreDe(r)) + '</b>';
        if (r.error) return '<li>' + nombre + ': no se ha podido calcular (' + esc(r.error) + ').</li>';
        const detalle = r.diferencias.map(function (d) {
          const c = TarifaCasosPrueba.cuanto(d);
          return esc(d.resultado.etiqueta) + ': esperado ' + esc(TarifaCasosPrueba.formatear(d.resultado, d.esperado))
            + ', ahora ' + esc(TarifaCasosPrueba.formatear(d.resultado, d.obtenido)) + (c ? ' (' + esc(c) + ')' : '');
        });
        return '<li>' + nombre + ': ' + detalle.join('; ') + '.</li>';
      });
      return '<p>Con los cambios que hay en pantalla, estos casos ya no dan lo esperado:</p><ul class="ed-aviso-casos">'
        + lineas.join('') + '</ul><p>«Cancelar» no publica nada. Si el cambio es el que se quería, después de publicar se puede '
        + 'actualizar el esperado de cada caso con «Usar el resultado actual como esperado».</p>';
    },
    escaparHtml: function (t) {
      return String(t === null || t === undefined ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },
    enviar: function (aEnviar) {
      const self = this;
      TarifaHerramienta.save(aEnviar).then(function () {
        self.$f7.toast.create({ text: 'Guardado', closeTimeout: 2000, position: 'center' }).open();
        self.editing = null;
        self.cargar();
      }).catch(function (e) { self.$f7.dialog.alert(e.message || 'Error al guardar'); });
    },
    /**
     * Lee la configuracion global con la que se calculan los casos. `forzar` vuelve a pedirla aunque
     * ya se tenga, que es lo que hace el guardado: se comprueba con la vigente en ese momento.
     *
     * Siempre resuelve, nunca rechaza: si no se puede leer, `cfgCasos` queda a `null` y los casos
     * salen como «no se ha podido calcular», que es un cambio que hay que contar y no un «todo
     * cuadra».
     */
    asegurarConfigCasos: function (forzar) {
      const self = this;
      if (this.estadoCfgCasos === 'ok' && !forzar) return Promise.resolve(this.cfgCasos);
      this.estadoCfgCasos = 'leyendo';
      return Tarifa.getConfig(true).then(function (r) {
        self.cfgCasos = TarifaCasosPrueba.configGlobal(r);
        self.estadoCfgCasos = self.cfgCasos ? 'ok' : 'error';
        return self.cfgCasos;
      }).catch(function () {
        self.cfgCasos = null;
        self.estadoCfgCasos = 'error';
        return null;
      });
    },
    addCaso: function () {
      if (!Array.isArray(this.editing.casosPrueba)) this.$set(this.editing, 'casosPrueba', []);
      const form = {};
      if (this.hasSubtipos && this.subtipoKeys.length) form.srv = this.subtipoKeys[0];
      this.editing.casosPrueba.push({ nombre: '', form: form, esperado: {} });
      this.asegurarConfigCasos(false);
    },
    delCaso: function (ci) {
      const self = this;
      this.$f7.dialog.confirm('Eliminar este caso de prueba?', function () {
        self.editing.casosPrueba.splice(ci, 1);
      });
    },
    /**
     * Escribe un dato de entrada del caso. Que se guarda y que se quita lo decide `conDato` del modulo,
     * la misma regla con la que calcula `formDelCaso`: vacio vuelve al valor por defecto, y `0`,
     * `false` o una tabla sin filas se guardan. Aqui solo se convierte lo tecleado a su tipo. El `form`
     * se sustituye entero para que el caso se recalcule.
     */
    setDatoCaso: function (caso, campo, valor, tipo) {
      let v = valor;
      if (tipo === 'casilla') v = !!valor;
      else if (tipo === 'numero') v = valor === '' ? '' : Number(valor);
      else if (tipo === 'libre') v = this.valorLibre(valor);
      this.$set(caso, 'form', TarifaCasosPrueba.conDato(caso.form, campo, v));
    },
    /** Lo que el caso calcula para ese dato, puesto o por defecto: lo que tiene que enseñar su control. */
    valorDelCaso: function (caso, campo) {
      return TarifaCasosPrueba.valorDelCaso(this.definicionCasos || this.editing, caso && caso.form, campo);
    },
    /**
     * Lo que usa el cálculo para un dato que el caso no trae: el valor de la calculadora sin tocar,
     * o los minutos del subtipo en una herramienta manual. Se enseña en la caja vacía para que la
     * pestaña no diga «vacío» mientras el caso calcula con otra cosa.
     */
    porDefectoCaso: function (caso, campo) {
      if (!this.definicionCasos) return '';
      const v = TarifaCasosPrueba.porDefecto(this.definicionCasos, caso && caso.form, campo);
      return v === undefined || v === null || typeof v === 'object' ? '' : String(v);
    },
    /** La opción vacía de un desplegable: dice cuál toma el cálculo si no se elige ninguna. */
    sinTeclearCaso: function (caso, campo) {
      const v = this.porDefectoCaso(caso, campo);
      if (!v) return '—';
      let etiqueta = v;
      if (campo === 'srv') {
        const op = this.editing.subtipos && this.editing.subtipos.opciones && this.editing.subtipos.opciones[v];
        etiqueta = (op && op.nombre) || v;
      } else {
        const w = this.camposDeEntrada.filter(function (x) { return x.campo === campo; })[0];
        const o = w && w.opciones && w.opciones.filter(function (x) { return x.key === v; })[0];
        etiqueta = (o && (o.label || o.key)) || v;
      }
      return '— (' + etiqueta + ')';
    },
    casillaDelCaso: function (caso, campo) {
      return !!this.valorDelCaso(caso, campo);
    },
    filaMarcadaCaso: function (caso, campo, fila) {
      const t = this.valorDelCaso(caso, campo);
      return !!(t && typeof t === 'object' && t[fila]);
    },
    /** Marca o desmarca una fila de una tabla de casillas; la regla vive en `conFila` del modulo. */
    setFilaCaso: function (caso, campo, fila, marcada) {
      this.$set(caso, 'form', TarifaCasosPrueba.conFila(this.definicionCasos || this.editing, caso.form, campo, fila, marcada));
    },
    /** «3» es el numero 3, «true»/«false» son casillas; lo demas, texto tal cual. */
    valorLibre: function (valor) {
      const t = String(valor === null || valor === undefined ? '' : valor).trim();
      if (t === '') return '';
      if (t === 'true') return true;
      if (t === 'false') return false;
      const n = Number(t.replace(',', '.'));
      return isFinite(n) ? n : t;
    },
    addOtroDato: function (caso) {
      const clave = String(this.nuevoDatoClave || '').trim();
      if (!clave) return;
      this.setDatoCaso(caso, clave, this.nuevoDatoValor, 'libre');
      this.nuevoDatoClave = '';
      this.nuevoDatoValor = '';
    },
    /** Los datos del caso que no tienen caja propia arriba. */
    otrosDatosDe: function (caso) {
      const propios = { srv: true, km: true };
      this.camposDeEntrada.forEach(function (w) { propios[w.campo] = true; });
      return Object.keys((caso && caso.form) || {}).filter(function (k) { return !propios[k]; });
    },
    setEsperadoCaso: function (caso, resultado, valor) {
      if (!caso.esperado) this.$set(caso, 'esperado', {});
      const t = String(valor === null || valor === undefined ? '' : valor).trim();
      if (t === '') { this.$delete(caso.esperado, resultado.clave); return; }
      if (resultado.tipo === 'texto') { this.$set(caso.esperado, resultado.clave, t); return; }
      const n = Number(t.replace(',', '.'));
      if (isFinite(n)) this.$set(caso.esperado, resultado.clave, n);
    },
    resultadoDelCaso: function (ci) {
      return this.resultadosCasos[ci] || null;
    },
    nombreDelCaso: function (ci) {
      return TarifaCasosPrueba.nombreDe({ caso: this.editing.casosPrueba[ci] }, ci);
    },
    estadoDelCaso: function (ci) {
      if (this.estadoCfgCasos !== 'ok') return { clase: 'pend', texto: 'Sin calcular' };
      const r = this.resultadoDelCaso(ci);
      if (!r || r.error) return { clase: 'mal', texto: 'No se puede calcular' };
      if (r.diferencias.length) return { clase: 'mal', texto: 'Cambia' };
      if (!r.comprobados) return { clase: 'pend', texto: 'Sin valores esperados' };
      return { clase: 'ok', texto: 'Da lo esperado' };
    },
    errorDelCaso: function (ci) {
      const r = this.resultadoDelCaso(ci);
      return r && r.error ? r.error : '';
    },
    obtenidoDelCaso: function (ci, resultado) {
      const r = this.resultadoDelCaso(ci);
      if (!r || !r.obtenido) return '—';
      return TarifaCasosPrueba.formatear(resultado, r.obtenido[resultado.clave]);
    },
    diferenciaDe: function (ci, clave) {
      const r = this.resultadoDelCaso(ci);
      if (!r) return null;
      return r.diferencias.filter(function (d) { return d.resultado.clave === clave; })[0] || null;
    },
    cuantoDe: function (ci, clave) {
      const d = this.diferenciaDe(ci, clave);
      return d ? TarifaCasosPrueba.cuanto(d) : '';
    },
    puedeTomarComoEsperado: function (ci) {
      const r = this.resultadoDelCaso(ci);
      return !!(r && r.obtenido && !r.error);
    },
    usarResultadoComoEsperado: function (ci) {
      const r = this.resultadoDelCaso(ci);
      if (!r || !r.obtenido) return;
      const permitidos = this.resultadosDelCaso.map(function (x) { return x.clave; });
      const nuevo = TarifaCasosPrueba.esperadoDesde(r.obtenido);
      Object.keys(nuevo).forEach(function (k) { if (permitidos.indexOf(k) < 0) delete nuevo[k]; });
      this.$set(this.editing.casosPrueba[ci], 'esperado', nuevo);
    },
    previewHerramienta: function () {
      if (this.editing && this.editing.codigo) {
        this.$f7.views.current.router.navigate('/tarifas/calculador-v3/' + this.editing.codigo + '/');
      }
    },
    /*
     * Todo lo que toca `secciones` y `alertas` ANOTA la edicion (#387). Son las unicas puertas de
     * entrada y de salida de esas dos raices: el editor las pinta con un `v-for`, asi que lo que la
     * persona escriba dentro de una seccion o de una alerta -su titulo, su mensaje, su condicion-
     * exige que esa seccion o esa alerta exista, y existir solo se consigue por un `add` de aqui.
     * Por eso basta con anotar en estos metodos, y por eso no queda ni un `push`, `splice` o `$set`
     * sobre esas dos raices suelto en el `<template>`: lo vigila el banco.
     */
    addSeccion: function () {
      if (!this.editing.secciones) this.$set(this.editing, 'secciones', []);
      this.editing.secciones.push({ titulo: 'Nueva seccion', headerColor: 'navy', gridCols: 3, widgets: [], _visCampo: '', _visOp: '===', _visVal: '' });
      this.edicion.anota('secciones');
    },
    delSeccion: function (i) {
      var self = this;
      this.$f7.dialog.confirm('Eliminar esta seccion y todos sus campos?', function () {
        self.editing.secciones.splice(i, 1);
        self.edicion.anota('secciones');
      });
    },
    moveSec: function (i, dir) {
      const arr = this.editing.secciones;
      const t = arr[i];
      this.$set(arr, i, arr[i + dir]);
      this.$set(arr, i + dir, t);
      this.edicion.anota('secciones');
    },
    /**
     * El valor tecleado, convertido en el literal que va dentro de la condicion.
     *
     * Antes era `isNaN(v) ? "'"+v+"'" : v`, y eso dejaba escrito tal cual lo tecleado siempre que
     * `isNaN` lo diera por numero: `.5`, `1.`, `1e3` o `0x10` viajaban a la base como literales de
     * JavaScript. Funcionaban mientras la pantalla ejecutaba la condicion con `new Function`; desde
     * que se interpreta (`expresion-condicion.js`) conviene que lo guardado sea la forma canonica del
     * numero, que es ademas lo que lee quien revise la condicion en la ficha.
     *
     * Y el vacio se cita: sin comillas la condicion quedaba cortada (`form.srv===`) y no evaluaba, o
     * sea una seccion siempre visible o una alerta que no sale nunca.
     */
    literalDeValor: function (v) {
      const txt = v === null || v === undefined ? '' : String(v);
      const n = Number(txt);
      if (txt.trim() !== '' && isFinite(n)) return String(n);
      return "'" + txt.replace(/\\/g, '\\\\').replace(/'/g, "\\'") + "'";
    },
    applyVisibleSec: function (sec) {
      this.edicion.anota('secciones');
      if (!sec._visCampo) { sec.visible = ''; return; }
      this.$set(sec, 'visible', 'form.' + sec._visCampo + sec._visOp + this.literalDeValor(sec._visVal));
    },
    addWidget: function (sec) {
      if (!sec.widgets) this.$set(sec, 'widgets', []);
      sec.widgets.push({ tipo: 'number', campo: '', label: '', hint: '', min: 0, step: 1, _visCampo: '', _visOp: '===', _visVal: '' });
      this.editingWidget = { si: this.editing.secciones.indexOf(sec), wi: sec.widgets.length - 1 };
      this.edicion.anota('secciones');
    },
    delWidget: function (sec, wi) {
      var self = this;
      this.$f7.dialog.confirm('Eliminar este campo?', function () {
        sec.widgets.splice(wi, 1);
        self.editingWidget = null;
        self.edicion.anota('secciones');
      });
    },
    moveWidget: function (sec, wi, dir) {
      const arr = sec.widgets;
      const t = arr[wi];
      this.$set(arr, wi, arr[wi + dir]);
      this.$set(arr, wi + dir, t);
      this.edicion.anota('secciones');
    },
    editWidget: function (si, wi) {
      this.editingWidget = (this.editingWidget && this.editingWidget.si === si && this.editingWidget.wi === wi) ? null : { si: si, wi: wi };
    },
    addOption: function (w) {
      if (!w.options) this.$set(w, 'options', []);
      w.options.push({ key: '', label: '', icono: '' });
      this.edicion.anota('secciones');
    },
    delOption: function (w, oi) {
      w.options.splice(oi, 1);
      this.edicion.anota('secciones');
    },
    applyVisibleWidget: function (w) {
      this.edicion.anota('secciones');
      if (!w._visCampo) { w.visible = ''; return; }
      this.$set(w, 'visible', 'form.' + w._visCampo + w._visOp + this.literalDeValor(w._visVal));
    },
    toggleSubtipos: function () {
      this.hasSubtipos = !this.hasSubtipos;
      if (this.hasSubtipos && (!this.editing.subtipos || !this.editing.subtipos.opciones)) {
        this.$set(this.editing, 'subtipos', { campo: 'srv', opciones: {} });
      }
    },
    addSubtipo: function () {
      var key = prompt('Clave del subtipo (ej: publica, industria):');
      if (!key) return;
      if (!this.editing.subtipos.opciones) this.$set(this.editing.subtipos, 'opciones', {});
      this.$set(this.editing.subtipos.opciones, key, { nombre: key, icono: '', norma: '', descripcion: '', params: {} });
    },
    delSubtipo: function (sk) {
      var self = this;
      this.$f7.dialog.confirm('Eliminar subtipo ' + sk + '?', function () { self.$delete(self.editing.subtipos.opciones, sk); });
    },
    addParam: function (sk) {
      if (!this.newParamKey) return;
      this.$set(this.editing.subtipos.opciones[sk].params, this.newParamKey, this.newParamVal);
      this.newParamKey = '';
      this.newParamVal = 0;
    },
    delParam: function (sk, pk) { this.$delete(this.editing.subtipos.opciones[sk].params, pk); },
    insertFormula: function (target, text) {
      if (target === 'tpc') this.formulaTpc += text;
      else this.formulaTpi += text;
      this.edicion.anota('formula');
    },
    addAlerta: function () {
      if (!this.editing.alertas) this.$set(this.editing, 'alertas', []);
      this.editing.alertas.push({ condicion: '', mensaje: '', tipo: 'warn', _campo: '', _op: '<', _val: '' });
      this.edicion.anota('alertas');
    },
    delAlerta: function (ai) {
      this.editing.alertas.splice(ai, 1);
      this.edicion.anota('alertas');
    },
    applyAlertaCond: function (al) {
      this.edicion.anota('alertas');
      if (!al._campo) return;
      this.$set(al, 'condicion', '(form.' + al._campo + '||0)' + al._op + this.literalDeValor(al._val));
    }
  }
};
</script>

<style scoped>
.ed-wrap{padding:12px;max-width:1200px;margin:0 auto}
.ed-top{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px}
.ed-title{font-size:16px;font-weight:700;color:#1a2744;margin:0}
.ed-grid{display:flex;flex-direction:column;gap:6px}
.ed-card{display:flex;flex-wrap:wrap;align-items:center;gap:10px;padding:8px 12px;background:#fff;border:1px solid #e2e8f0;border-radius:8px}
/* El motivo de que «Duplicar» este deshabilitado, en su propia linea de la tarjeta: ocupa el ancho
   entero para no estrechar la fila que ya habia. Sin `gap` ni `min()`: el `browserslist` de este
   repo no los soporta. */
.ed-nodup{flex:0 0 100%;margin:4px 0 0;font-size:9px;line-height:1.4;color:#991b1b}
.ed-btn:disabled{opacity:.5;cursor:not-allowed}
/* Casos de prueba (#1185) */
.ed-casos-intro{font-size:11px;color:#475569;margin:0 0 8px}
.ed-casos-vacio{font-size:11px;color:#94a3b8;margin:0 0 8px}
.ed-casos-aviso{font-size:11px;padding:6px 10px;border-radius:6px;background:#eff6ff;color:#1e3a5f;margin:0 0 8px}
.ed-casos-aviso-mal{background:#fef2f2;color:#991b1b}
.ed-caso-estado{font-size:9px;font-weight:700;padding:2px 8px;border-radius:10px;margin-right:6px}
.ed-caso-ok{background:#dcfce7;color:#166534}
.ed-caso-mal{background:#fee2e2;color:#991b1b}
.ed-caso-pend{background:#f1f5f9;color:#475569}
.ed-caso-tabla{width:100%;border-collapse:collapse;font-size:11px;margin:8px 0}
.ed-caso-tabla th{text-align:left;font-size:9px;color:#64748b;text-transform:uppercase;padding:4px;border-bottom:1px solid #e2e8f0}
.ed-caso-tabla td{padding:4px;border-bottom:1px solid #f1f5f9}
.ed-caso-tabla input{border:1px solid #d1d9e0;border-radius:4px;padding:3px 6px;font-size:11px;width:110px}
.ed-caso-fila-mal td{background:#fef2f2}
.ed-caso-cuanto{color:#991b1b;font-weight:700}
.ed-caso-filas{display:flex;flex-wrap:wrap;gap:4px 14px;font-size:11px}
.ed-caso-filas label{display:flex;align-items:center;gap:4px;font-weight:400;margin:0}
.ed-previa-caso{margin-top:4px;color:#166534}
.ed-ico{font-size:20px}
.ed-info{flex:1}
.ed-info b{font-size:12px;display:block;color:#1a2744}
.ed-fam{font-size:9px;color:#94a3b8;text-transform:uppercase}
.ed-badge{font-size:8px;font-weight:700;padding:2px 8px;border-radius:10px}
.ed-on{background:#dcfce7;color:#166534}
.ed-off{background:#fee2e2;color:#991b1b}
.ed-btn{padding:5px 12px;border:none;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;font-family:inherit}
.ed-btn-p{background:#E8901A;color:#fff}
.ed-btn-p:hover{background:#d97f0a}
.ed-btn-s{background:#f1f5f9;color:#475569;border:1px solid #e2e8f0}
.ed-btn-sm{font-size:9px;padding:3px 8px}
.ed-btn-mini{background:none;border:1px solid #d1d9e0;border-radius:4px;padding:1px 5px;font-size:9px;cursor:pointer;color:#64748b}
.ed-del{color:#dc2626;border-color:#fecaca}
.ed-del-btn{background:#fee2e2;color:#dc2626;border:1px solid #fecaca}
.ed-editor{display:flex;flex-direction:column;height:calc(100vh - 44px);overflow:hidden}
.ed-tabs{display:flex;align-items:center;gap:4px;padding:6px 12px;background:#1a2744;flex-shrink:0;flex-wrap:wrap}
.ed-tab{padding:5px 12px;border:none;border-radius:6px;font-size:11px;font-weight:600;cursor:pointer;font-family:inherit;background:rgba(255,255,255,.08);color:rgba(255,255,255,.6)}
.ed-tab.act{background:#E8901A;color:#fff}
.ed-tab:hover{color:#fff}
.ed-body{flex:1;overflow-y:auto;background:#f0f2f5;padding:12px}
.ed-panel{max-width:900px;margin:0 auto}
.ed-section{background:#fff;border:1px solid #e2e8f0;border-radius:8px;padding:14px;margin-bottom:10px}
.ed-sh{font-size:13px;font-weight:700;color:#1a2744;margin:0 0 10px}
.ed-row{display:flex;gap:10px;margin-bottom:8px;flex-wrap:wrap}
.ed-field{flex:1;min-width:150px;display:flex;flex-direction:column;gap:3px}
.ed-field-full{flex:3;min-width:300px}
.ed-field label{font-size:9px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.05em}
.ed-field input,.ed-field select,.ed-field textarea{border:1px solid #d1d9e0;border-radius:5px;padding:6px 8px;font-size:12px;font-family:inherit;background:#f8fafc;width:100%;box-sizing:border-box}
.ed-field input:focus,.ed-field select:focus,.ed-field textarea:focus{border-color:#E8901A;outline:none;background:#fff}
.ed-field input:disabled{background:#f1f5f9;color:#94a3b8}
.ed-hint{font-weight:400;color:#94a3b8;text-transform:none;letter-spacing:0}
.ed-toggle{display:inline-block;padding:4px 14px;border-radius:20px;font-size:11px;font-weight:700;cursor:pointer;background:#f1f5f9;color:#94a3b8;border:1px solid #e2e8f0;user-select:none}
.ed-toggle.on{background:#dcfce7;color:#166534;border-color:#bbf7d0}
.ed-emoji-grid{display:flex;flex-wrap:wrap;gap:3px}
.ed-emoji{width:28px;height:28px;border:1px solid #e2e8f0;border-radius:5px;background:#f8fafc;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center}
.ed-emoji.act{border-color:#E8901A;background:#fffbeb}
.ed-slider-wrap{display:flex;align-items:center;gap:8px}
.ed-slider{flex:1;accent-color:#E8901A}
.ed-slider-val{font-size:14px;font-weight:700;color:#E8901A;min-width:40px}
.ed-section-top{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px}
.ed-sec-list{display:flex;flex-direction:column;gap:8px}
.ed-sec-card{background:#fff;border:1px solid #e2e8f0;border-radius:8px;overflow:hidden}
.ed-sec-header{padding:6px 10px;display:flex;justify-content:space-between;align-items:center;color:#fff;font-size:11px;font-weight:700}
.ed-sec-body{padding:10px}
.ed-campos-header{display:flex;justify-content:space-between;align-items:center;margin:8px 0 4px;padding-top:8px;border-top:1px solid #e2e8f0}
.ed-campos-header b{font-size:10px;color:#64748b}
.ed-campo{border:1px solid #f0f0f0;border-radius:5px;margin-bottom:4px;overflow:hidden}
.ed-campo-bar{display:flex;align-items:center;gap:6px;padding:4px 8px;background:#f8fafc;font-size:10px}
.ed-campo-tipo{background:#e2e8f0;padding:1px 6px;border-radius:3px;font-weight:700;font-size:8px;color:#475569}
.ed-campo-slug{color:#94a3b8;font-size:9px}
.ed-campo-bar div:last-child{margin-left:auto;display:flex;gap:2px}
.ed-campo-edit{padding:8px;background:#fffbeb;border-top:1px solid #fde68a}
.ed-opts{margin-top:6px;padding:6px;background:#f8fafc;border-radius:5px}
.ed-opts label{font-size:9px;font-weight:700;color:#64748b;display:block;margin-bottom:4px}
.ed-opt{display:flex;gap:4px;margin-bottom:3px;align-items:center}
.ed-opt input{padding:3px 5px;font-size:10px;border:1px solid #d1d9e0;border-radius:3px}
.ed-cond{display:flex;gap:4px;align-items:center;flex-wrap:wrap}
.ed-cond select,.ed-cond input{padding:3px 6px;font-size:10px;border:1px solid #d1d9e0;border-radius:3px}
.ed-vis-tag{background:#dbeafe;color:#1e40af;padding:1px 6px;border-radius:3px;font-size:8px;font-weight:600}
.ed-params{margin-top:6px;padding:6px;background:#f8fafc;border-radius:5px}
.ed-params label{font-size:9px;font-weight:700;color:#64748b;display:block;margin-bottom:4px}
.ed-param-row{display:flex;gap:4px;margin-bottom:3px;align-items:center}
.ed-param-row input{padding:3px 5px;font-size:10px;border:1px solid #d1d9e0;border-radius:3px}
.ed-pk{width:80px;background:#f1f5f9}
.ed-param-add{display:flex;gap:4px;margin-top:4px;align-items:center}
.ed-formula-builder{margin-top:6px}
.ed-formula-chips{display:flex;flex-wrap:wrap;gap:3px;margin-bottom:6px}
.ed-chip{padding:2px 8px;border-radius:4px;font-size:9px;font-weight:600;cursor:pointer;background:#dbeafe;color:#1e40af;border:1px solid #bfdbfe}
.ed-chip:hover{background:#bfdbfe}
.ed-chip-param{background:#dcfce7;color:#166534;border-color:#bbf7d0}
.ed-chip-op{background:#f1f5f9;color:#475569;border-color:#e2e8f0;font-family:monospace}
.ed-formula-input{width:100%;border:1px solid #d1d9e0;border-radius:5px;padding:8px;font-size:12px;font-family:'Courier New',monospace;background:#1a2744;color:#7dd3fc;box-sizing:border-box}
.ed-formula-input:focus{outline:none;border-color:#E8901A}
.ed-formula-preview{padding:6px 10px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:5px;font-size:11px;color:#0369a1;margin-top:4px}
.ed-formula-preview b{color:#1a2744;font-size:13px}
.ed-ver-fecha{font-size:9px;color:#16a34a}
.ed-ver-section{margin-top:12px;padding:10px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px}
.ed-ver-title{font-size:10px;font-weight:700;color:#fff;background:#1a2744;padding:4px 8px;border-radius:4px;margin-bottom:8px;letter-spacing:.05em}
.ed-ver-grid{display:flex;gap:16px;flex-wrap:wrap}
.ed-ver-item{display:flex;flex-direction:column;gap:1px}
.ed-ver-lbl{font-size:9px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:.04em}
.ed-ver-val{font-size:11px;font-weight:600;color:#1e293b}
.ed-ver-vigente{color:#16a34a}
</style>
